import { saveAs } from "file-saver";
import { downloadAllGroupDataImportTemplates } from "../../../../components/DataImportModal/utils/groupDataImportUtils";
import { getReactivationsTableRows } from "../fullReturnSections/allocatedReactivations";
import { getDisallowancesTableRows } from "../fullReturnSections/allocatedRestrictions";
import { getCirAttributesSection } from "../sections/cirAttributes";
import { getCirCalculationsSection } from "../sections/cirCalculations";
import { getFullAccountingPeriodsSection } from "../sections/fullAccountingPeriods";
import { getGroupSummaryAndCompaniesSection } from "../sections/groupSummaryAndCompanies";
import { getInstructionsSection } from "../sections/instructions";
import { getRegardedAccountingPeriodsSection } from "../sections/regardedAccountingPeriods";
import {
  addSheetStyle,
  adjustHeadersAlignment,
  getJsonFileName,
  setupExcelAccountingPeriodsData,
  setupExcelAdjustedCapsData,
  styleAllocatedReactivationColumns,
  styleAllocatedRestrictionsColumns,
  styleDynamicAPColumns,
  styleDynamicGroupSummaryColumns,
} from "./helpers";
import { getExcelData } from "./metrics";
const ExcelJS = require("exceljs");

export function getSheetStylesConfig(isClientFacing) {
  return [
    {
      name: isClientFacing ? "Instructions" : "Disclaimer",
      getRows: getInstructionsSection,
      styles: {
        boldRows: isClientFacing ? [] : [7, 9, 11],
        redTextCells: isClientFacing ? [] : ["A7", "A17"],
        rowFontSizes: isClientFacing
          ? {}
          : {
              7: 15,
            },
        columnWidths: {
          1: 150,
        },
        wrapText: [1],
      },
    },
    {
      name: "Group summary and companies",
      getRows: getGroupSummaryAndCompaniesSection,
      styleDynamicColumns: styleDynamicGroupSummaryColumns,
      styles: {
        boldRows: [2, 23],
        numberFormatRows: [5, 7, 9, 10, 11, 12, 13, 14, 16, 18, 19],
        numberFormatColumns: [5, 6],
        columnWidths: {
          1: 5,
          2: 50,
        },
        horizontalRightAlignmentCols: [3, 4],
        leftAlignedRows: [23],
        percentageDecimalFormat: [20],
      },
    },
    {
      name: "CIR Attributes",
      getRows: getCirAttributesSection,
      styles: {
        boldRows: [2, 8, 10, 11, 15, 18, 22, 26, 28],
        underlineBoldRows: [1, 14],
        italicCells: ["A21"],
        numberFormatRows: [
          4, 6, 7, 8, 10, 11, 16, 17, 18, 20, 21, 22, 24, 25, 26, 28,
        ],
        columnWidths: {
          1: 50,
          2: 20,
          3: 15,
        },
        wrapText: [1],
        horizontalRightAlignmentCols: [2],
        noWrapTextCells: ["A31", "A32", "A33", "A34"],
      },
    },
    {
      name: "CIR Calculations",
      getRows: getCirCalculationsSection,
      styles: {
        boldRows: [2, 16, 36, 37],
        underlineBoldRows: [1, 15, 33],
        numberFormatCells: [
          "C3",
          "C4",
          "C6",
          "C7",
          "C8",
          "C10",
          "C11",
          "C12",
          "C17",
          "C18",
          "C21",
          "C22",
          "C24",
          "C25",
          "C26",
          "C28",
          "C29",
          "C30",
          "C38",
          "C39",
          "C41",
          "C43",
          "C45",
          "C47",
          "C49",
        ],
        percentageFormatCells: ["C19"],
        columnWidths: {
          1: 40,
          2: 25,
          3: 15,
        },
        wrapText: [1],
        horizontalRightAlignmentCols: [2],
      },
    },
    {
      name: "Accounting Periods (Full)",
      getRows: getFullAccountingPeriodsSection,
      styleDynamicColumns: styleDynamicAPColumns,
      adjustHeadersAlignment,
      frozenRows: 6,
      sheetScalePercentage: 68,
      styles: {
        boldRows: [
          1, 8, 10, 25, 27, 41, 43, 58, 60, 74, 76, 88, 90, 91, 94, 99, 101,
          131, 132,
        ],
        italicRows: [12, 29, 45, 62, 78],
        numberFormatRows: [
          11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 28, 30, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 44, 46, 47, 48, 49, 50, 51,
          52, 53, 54, 55, 56, 57, 58, 61, 63, 64, 65, 66, 67, 68, 69, 70, 71,
          72, 73, 74, 77, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 95,
          96, 97, 98, 99, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 128, 129, 130, 131, 132,
        ],
        columnWidths: {
          1: 60,
        },
        wrapText: [1],
        percentageFormat: [8],
      },
    },
    {
      name: "Accounting Periods (Regarded)",
      getRows: getRegardedAccountingPeriodsSection,
      styleDynamicColumns: styleDynamicAPColumns,
      adjustHeadersAlignment,
      frozenRows: 11,
      sheetScalePercentage: 71,
      styles: {
        boldRows: [
          1, 13, 15, 30, 32, 46, 48, 63, 65, 79, 81, 93, 95, 96, 100, 105, 107,
          137, 138, 146, 153,
        ],
        italicRows: [17, 34, 50, 67, 83],
        numberFormatRows: [
          16, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 33, 35, 36,
          37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 49, 51, 52, 53, 54, 55, 56,
          57, 58, 59, 60, 61, 62, 63, 66, 68, 69, 70, 71, 72, 73, 74, 75, 76,
          77, 78, 79, 82, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 95, 96, 101,
          102, 103, 104, 105, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117,
          118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131,
          132, 133, 134, 135, 136, 137, 138,
        ],
        columnWidths: {
          1: 40,
        },
        wrapText: [1],
        percentageFormat: [8],
      },
    },
    {
      name: undefined,
      addSheetsGroup: downloadAllGroupDataImportTemplates,
    },
    {
      name: "Allocated Restrictions",
      getRows: getDisallowancesTableRows,
      extraStartRows: ["", "", "", "", ""],
      styleDynamicColumns: styleAllocatedRestrictionsColumns,
      styles: {
        boldRows: [2],
        columnWidths: {
          1: 2,
          2: 100,
          3: 20,
          4: 40,
          5: 30,
        },
        rowHeights: {
          1: 5,
        },
        wrapTextCells: ["E2"],
        numberFormatColumns: [4],
      },
    },
    {
      name: "Allocated Reactivations",
      getRows: getReactivationsTableRows,
      styleDynamicColumns: styleAllocatedReactivationColumns,
      extraStartRows: ["", "", "", "", ""],
      styles: {
        boldRows: [2],
        columnWidths: {
          1: 2,
          2: 100,
          3: 30,
          4: 40,
          5: 30,
        },
        rowHeights: {
          1: 5,
        },
        wrapTextCells: ["E2"],
        numberFormatColumns: [3, 4],
      },
    },
  ];
}

const getFreezeHeadersConfig = (xSplit, ySplit) => {
  return { views: [{ state: "frozen", xSplit, ySplit }] };
};

export const pageMargins = {
  left: 0.25,
  right: 0.25,
  top: 0.25,
  bottom: 0.25,
  header: 0,
  footer: 0,
};

export async function downloadExcel(isClientFacing = true) {
  const companies = [];
  const excelData = getExcelData();
  const sheetStylesConfig = getSheetStylesConfig(isClientFacing);
  const firstSheetName = sheetStylesConfig[0].name;

  setupExcelAdjustedCapsData(excelData, companies);
  setupExcelAccountingPeriodsData(excelData);

  const workBook = new ExcelJS.Workbook();

  for (const config of sheetStylesConfig) {
    if (config.name) {
      const frozenRows = config.frozenRows;
      const freezeHeadersConfig = frozenRows
        ? getFreezeHeadersConfig(1, frozenRows)
        : {};
      const sheetScale = config.sheetScalePercentage;

      const newWorksheet = workBook.addWorksheet(
        config.name,
        freezeHeadersConfig,
      );

      let rows = config.getRows(excelData, isClientFacing);
      if (config.extraStartRows) rows = [config.extraStartRows, ...rows];
      newWorksheet.addRows(rows);

      if (frozenRows) {
        newWorksheet.pageSetup = {
          ...newWorksheet.pageSetup,
          printTitlesRow: `1:${frozenRows}`,
          printTitlesColumn: "A:A",
          scale: sheetScale ?? 100,
          orientation: "landscape",
          margins: pageMargins,
        };
      }

      addSheetStyle(newWorksheet, config.styles);

      if (config.styleDynamicColumns)
        config.styleDynamicColumns(newWorksheet, rows.length);

      if (config.adjustHeadersAlignment)
        config.adjustHeadersAlignment(newWorksheet);
    } else {
      await config.addSheetsGroup({
        existingWorkbook: workBook,
        isImportTemplate: false,
      });
    }
  }

  await saveSummaryOutput(workBook, firstSheetName, isClientFacing);
}

const saveSummaryOutput = async (workBook, firstSheetName, isClientFacing) => {
  const excelFileName = getJsonFileName() + ".xlsx";
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  if (isClientFacing) {
    const buffer = await workBook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: fileType });
    saveAs(blob, excelFileName);
    return;
  }

  const firstWorksheet = workBook.getWorksheet(firstSheetName);
  const imagePath = "/pwc_logo.png";
  let imageId;
  await fetch(imagePath)
    .then((response) => response.blob())
    .then((blob) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);

      reader.onload = async () => {
        imageId = workBook.addImage({
          base64: reader.result,
          extension: "png",
        });

        firstWorksheet.addImage(imageId, {
          tl: { col: 0, row: 0 },
          ext: { width: 163, height: 101 },
        });

        const buffer = await workBook.xlsx.writeBuffer();

        const blob = new Blob([buffer], { type: fileType });
        saveAs(blob, excelFileName);
      };
    })
    .catch((error) => console.error("Error fetching image:", error));
};
